module.exports = __webpack_public_path__ + "static/media/already-bet-check.ef7eda75.svg";